module.exports = __webpack_public_path__ + "static/img/2.3e0b6c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/2.png
// module id = ixGu
// module chunks = 13